import React from "react";
import YellowClock from "../../Components/SideBar/assets/icons/yellow-clock.png";

const RenderGridItems = ({
    items,
    attributeList,
    onUpdateIdSelected,
    idsSelected,
    setMultipleRecordsCheckedCheckbox,
    multipleRecordsCheckedCheckbox,
    readOnlyModal,
    disableModal }) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        getGridItems(items, items[0], attributeList, onUpdateIdSelected, idsSelected, setMultipleRecordsCheckedCheckbox, multipleRecordsCheckedCheckbox, readOnlyModal, disableModal)
    );
}

function getGridItems(rows, rowFirstItem, attributeList, onUpdateIdSelected, idsSelected, setMultipleRecordsCheckedCheckbox, multipleRecordsCheckedCheckbox, readOnlyModal = false, disableModal = false) {
    if (rowFirstItem && rowFirstItem.constructorList) {
        const sortedAttributes = rowFirstItem.constructorList.sort(
            (a, b) => a.presentationSequence - b.presentationSequence
        );
        return (
            <>
                {
                    sortedAttributes.map(
                        (attribute) => {
                            return (
                                <AttributeGrid
                                    key={attribute.presentationSequence}
                                    attributes={rows}
                                    attribute={attribute}
                                    attributeList={attributeList}
                                    onUpdateIdSelected={onUpdateIdSelected}
                                    idsSelected={idsSelected}
                                    setMultipleRecordsCheckedCheckbox={setMultipleRecordsCheckedCheckbox}
                                    multipleRecordsCheckedCheckbox={multipleRecordsCheckedCheckbox}
                                    readOnlyModal={readOnlyModal}
                                    disableModal={disableModal}
                                />
                            )
                        }
                    )
                }
            </>
        );
    }
}

function validateIfSameAttribute(attr1, attr2) {
    if (!attr1 || !attr2) {
        return false;
    }

    return attr1.toUpperCase() === attr2.toUpperCase();
}

function setAllCheckboxes(attributes, multipleRecordsCheckedCheckbox, onUpdateIdSelected) {
    const idsSelected = []
    if (onUpdateIdSelected) {
        attributes.forEach(attribute => {
            attribute.constructorList.forEach(attribute => {
                if (attribute.field && attribute.field.toUpperCase() === 'ID') {
                    const id = attribute.argument;

                    if (multipleRecordsCheckedCheckbox) {
                        if (!idsSelected.includes(id)) {
                            idsSelected.push(id);
                        }
                    }
                }
            });
        });

        onUpdateIdSelected(idsSelected);
        return idsSelected;
    }
}

function AttributeGrid({
    attributes,
    attribute,
    attributeList,
    onUpdateIdSelected,
    idsSelected,
    setMultipleRecordsCheckedCheckbox,
    multipleRecordsCheckedCheckbox,
    readOnlyModal,
    disableModal }) {

    let attributeDataFrontend;
    if (attributeList) {
        attributeDataFrontend = attributeList.find(obj => validateIfSameAttribute(obj.name, attribute.field)) || {};
    }

    if (!attribute.labelGrid || attributeDataFrontend.isVisible === 'N' || attributeDataFrontend.isVisible === false) {
        return null;
    }

    const labelGrid = attribute.visibleTitle === 'S' ? attribute.labelGrid : null;

    if (attributeDataFrontend && attributeDataFrontend.allowsMultipleRecordsSelected && (attribute.field && attribute.field.toUpperCase() === 'ID')) {
        if (!attribute.labelGrid) {
            return null;
        }

        return (
            <div key={attribute.presentationSequence} className="cell">
                <input
                    style={{ cursor: 'pointer' }}
                    type="checkbox"
                    className="checkbox-row-default"
                    readOnly={readOnlyModal}
                    disabled={disableModal}
                    onChange={(e) => {
                        const idsSelecteds = setAllCheckboxes(attributes, e.target.checked, onUpdateIdSelected);
                        setMultipleRecordsCheckedCheckbox((idsSelecteds && idsSelecteds.length > 0)
                            && (attributes && attributes.length > 0)
                            && idsSelecteds.length === attributes.length);
                    }}
                    checked={multipleRecordsCheckedCheckbox}
                />
            </div>
        );
    }

    let img = '';
    if (attribute && attribute.additionalParametersDTO &&
        attribute.additionalParametersDTO.balloon) {
        console.log(attribute)
        img = (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={YellowClock} alt="Yellow Clock" style={{ width: '30px', marginLeft: '8px' }} title={attribute.additionalParametersDTO.balloonValue} />
            </div>
        );
    }

    return (
        <div key={attribute.presentationSequence} className="cell">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {labelGrid}
                {img}
            </div>
        </div>
    );
}

const RenderSecondGridItems = ({ items }) => {
    if (!items || items.length === 0) {
        return null;
    }

    return getGridSecondItems(items[0]);
}

function getGridSecondItems(rowFirstItem) {
    if (rowFirstItem && rowFirstItem.constructorList) {
        const sortedAttributes = rowFirstItem.constructorList.sort(
            (a, b) => a.presentationSequence - b.presentationSequence
        );

        return (
            <>
                {sortedAttributes.map((attribute) => {
                    const hasAnyAdvancedArgument = sortedAttributes.some(attr => attr.argumentAdvanced && attr.argumentAdvanced.length > 0);
                    const hasAdvancedArgument = attribute.argumentAdvanced && attribute.argumentAdvanced.length > 0;

                    if (hasAnyAdvancedArgument) {
                        return (
                            <div key={attribute.presentationSequence} className="cell">
                                {hasAdvancedArgument
                                    ? attribute.argumentAdvanced.map((advancedAttr) => (
                                        getSecondAttributeGrid(advancedAttr)
                                    ))
                                    : <div key={attribute.presentationSequence} className="cell" />
                                }
                            </div>
                        );
                    } else {
                        return null;
                    }
                })}
            </>
        );
    }

    return null;
}

function getSecondAttributeGrid(attribute) {
    if (!attribute.labelGrid) {
        return null;
    }

    const labelGrid = attribute.visibleTitle === 'S' ? attribute.labelGrid : null;

    return (
        <div key={attribute.presentationSequence} className="cell">
            {labelGrid}
        </div>
    );
}

export default { RenderGridItems, RenderSecondGridItems };
